module.exports = __webpack_public_path__ + "img/receipt01.ea2afae9.jpg";